import React, { useState } from "react";
import SubPageLayout from "../../components/shared/SubPageLayout";

const EMAIL_TYPES = {
  CLIENT: "client",
  POTENTIAL_CLIENT: "potential_client",
  INTERNAL: "internal",
  EXTERNAL: "external",
};

const Email = () => {
  const [showEmailComposer, setShowEmailComposer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [selectedEmails, setSelectedEmails] = useState(new Set());
  const [replyToEmail, setReplyToEmail] = useState(null);
  const [selectedTypes, setSelectedTypes] = useState(
    new Set(Object.values(EMAIL_TYPES)),
  );
  const [emails, setEmails] = useState([
    {
      id: 1,
      sender: "Greg Paulman",
      senderEmail: "greg.paulman@digiset.com",
      subject: "Portfolio Review Meeting",
      preview:
        "I wanted to follow up on our discussion about scheduling the quarterly portfolio review meeting...",
      time: "10:23 AM",
      isStarred: true,
      hasAttachment: true,
      unread: true,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 2,
      sender: "Mary Thorsen",
      senderEmail: "mary.t@example.com",
      subject: "Investment Strategy Update",
      preview:
        "Based on the recent market changes, I think we should consider adjusting our approach to...",
      time: "9:45 AM",
      isStarred: false,
      hasAttachment: false,
      unread: true,
      type: EMAIL_TYPES.CLIENT,
    },
    {
      id: 3,
      sender: "Chris Mazzuca",
      senderEmail: "chris.m@digiset.com",
      subject: "Client Referral",
      preview:
        "I have a potential client who is interested in our retirement planning services...",
      time: "Yesterday",
      isStarred: true,
      hasAttachment: false,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 4,
      sender: "Alan Dunn",
      senderEmail: "alan.dunn@example.com",
      subject: "Market Analysis Report - Q2 2024",
      preview:
        "Attached is the comprehensive market analysis report for Q2 2024. Key highlights include...",
      time: "Yesterday",
      isStarred: false,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 5,
      sender: "Sarah Johnson",
      senderEmail: "sarah.j@example.com",
      subject: "Estate Planning Documents",
      preview:
        "Please find attached the updated estate planning documents for your review...",
      time: "Mar 15",
      isStarred: false,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 6,
      sender: "Michael Chen",
      senderEmail: "michael.chen@digiset.com",
      subject: "Risk Assessment Updates",
      preview:
        "Following our recent review, I have updated the risk assessment metrics for our high-net-worth clients...",
      time: "Mar 14",
      isStarred: false,
      hasAttachment: true,
      unread: true,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 7,
      sender: "Jennifer Walsh",
      senderEmail: "j.walsh@example.com",
      subject: "Retirement Planning Workshop",
      preview:
        "Would you be interested in co-hosting a retirement planning workshop next month? I think our clients would...",
      time: "Mar 14",
      isStarred: true,
      hasAttachment: false,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 8,
      sender: "Robert Martinez",
      senderEmail: "r.martinez@digiset.com",
      subject: "Compliance Update Required",
      preview:
        "Please review and sign the updated compliance documents by end of week. These changes reflect new regulations...",
      time: "Mar 13",
      isStarred: false,
      hasAttachment: true,
      unread: true,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 9,
      sender: "Lisa Thompson",
      senderEmail: "l.thompson@example.com",
      subject: "Tax Season Preparation",
      preview:
        "Here are the key dates and documents we need to prepare for the upcoming tax season...",
      time: "Mar 13",
      isStarred: false,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 10,
      sender: "David Kim",
      senderEmail: "d.kim@digiset.com",
      subject: "Investment Committee Meeting",
      preview:
        "Attached is the agenda for next week's investment committee meeting. Please review the proposed changes...",
      time: "Mar 12",
      isStarred: true,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 11,
      sender: "Emily Rodriguez",
      senderEmail: "e.rodriguez@example.com",
      subject: "Client Portfolio Review",
      preview:
        "I have completed the quarterly portfolio review for the Johnson family. Key findings include...",
      time: "Mar 12",
      isStarred: false,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 12,
      sender: "William Parker",
      senderEmail: "w.parker@digiset.com",
      subject: "New Software Training",
      preview:
        "We are rolling out new portfolio management software next month. Training sessions will be held...",
      time: "Mar 11",
      isStarred: false,
      hasAttachment: false,
      unread: true,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 13,
      sender: "Rachel Green",
      senderEmail: "r.green@example.com",
      subject: "ESG Investment Options",
      preview:
        "Based on increasing client interest, I have prepared an overview of our ESG investment options...",
      time: "Mar 11",
      isStarred: true,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 14,
      sender: "Thomas Anderson",
      senderEmail: "t.anderson@digiset.com",
      subject: "Market Volatility Report",
      preview:
        "Here is our analysis of recent market volatility and recommended actions for client portfolios...",
      time: "Mar 10",
      isStarred: false,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 15,
      sender: "Sandra Lee",
      senderEmail: "s.lee@example.com",
      subject: "Client Appreciation Event",
      preview:
        "I have secured the venue for our annual client appreciation event. Please review the proposed agenda...",
      time: "Mar 10",
      isStarred: false,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 16,
      sender: "James Wilson",
      senderEmail: "j.wilson@example.com",
      subject: "Interest in Wealth Management Services",
      preview:
        "After our meeting last week, I am very interested in learning more about your wealth management services...",
      time: "Mar 9",
      isStarred: false,
      hasAttachment: false,
      unread: true,
      type: EMAIL_TYPES.POTENTIAL_CLIENT,
    },
    {
      id: 17,
      sender: "Patricia Brown",
      senderEmail: "p.brown@digiset.com",
      subject: "Team Meeting Notes",
      preview:
        "Attached are the notes from yesterday's team meeting. Please review the action items...",
      time: "Mar 9",
      isStarred: false,
      hasAttachment: true,
      unread: false,
      type: EMAIL_TYPES.INTERNAL,
    },
    {
      id: 18,
      sender: "Mark Davis",
      senderEmail: "m.davis@example.com",
      subject: "Partnership Opportunity",
      preview:
        "Our firm is interested in exploring a potential partnership with Digiset for client referrals...",
      time: "Mar 8",
      isStarred: true,
      hasAttachment: false,
      unread: false,
      type: EMAIL_TYPES.EXTERNAL,
    },
    {
      id: 19,
      sender: "Helen Martinez",
      senderEmail: "h.martinez@example.com",
      subject: "Estate Planning Consultation",
      preview:
        "I would like to schedule a consultation to discuss estate planning options for my family...",
      time: "Mar 8",
      isStarred: false,
      hasAttachment: false,
      unread: true,
      type: EMAIL_TYPES.POTENTIAL_CLIENT,
    },
    {
      id: 20,
      sender: "Richard Taylor",
      senderEmail: "r.taylor@example.com",
      subject: "Portfolio Performance Review",
      preview:
        "Can we schedule a meeting to review my portfolio performance for the last quarter? I have some concerns about...",
      time: "Mar 7",
      isStarred: true,
      hasAttachment: false,
      unread: false,
      type: EMAIL_TYPES.CLIENT,
    },
  ]);

  const toggleStar = (emailId, e) => {
    e.stopPropagation();
    setEmails(
      emails.map((email) =>
        email.id === emailId
          ? { ...email, isStarred: !email.isStarred }
          : email,
      ),
    );
  };

  const toggleEmailSelection = (emailId, e) => {
    e.stopPropagation(); // Prevent email from opening
    setSelectedEmails((prev) => {
      const newSelection = new Set(prev);
      if (newSelection.has(emailId)) {
        newSelection.delete(emailId);
      } else {
        newSelection.add(emailId);
      }
      return newSelection;
    });
  };

  const handleReply = (email) => {
    setReplyToEmail(email);
    setShowEmailComposer(true);
    setSelectedEmail(null);
  };

  const handleForward = (email) => {
    setReplyToEmail({ ...email, subject: `Fwd: ${email.subject}` });
    setShowEmailComposer(true);
    setSelectedEmail(null);
  };

  const toggleEmailType = (type) => {
    setSelectedTypes((prev) => {
      const newTypes = new Set(prev);
      if (type === "all") {
        // If all types are currently selected, clear all. Otherwise, select all.
        return newTypes.size === Object.values(EMAIL_TYPES).length
          ? new Set()
          : new Set(Object.values(EMAIL_TYPES));
      }
      if (newTypes.has(type)) {
        newTypes.delete(type);
      } else {
        newTypes.add(type);
      }
      return newTypes;
    });
  };

  const filteredEmails = emails.filter((email) =>
    selectedTypes.has(email.type),
  );
  const totalEmails = filteredEmails.length;
  const unreadCount = filteredEmails.filter((email) => email.unread).length;
  const emailsPerPage = 10;
  const totalPages = Math.ceil(totalEmails / emailsPerPage);

  // Get current page's emails
  const indexOfLastEmail = currentPage * emailsPerPage;
  const indexOfFirstEmail = indexOfLastEmail - emailsPerPage;
  const currentEmails = filteredEmails.slice(
    indexOfFirstEmail,
    indexOfLastEmail,
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const openEmailDetail = (email) => {
    setSelectedEmail(email);
  };

  const markAllAsRead = () => {
    setEmails(emails.map((email) => ({ ...email, unread: false })));
  };

  const deleteEmails = (emailIds) => {
    setEmails(emails.filter((email) => !emailIds.includes(email.id)));
  };

  const refreshEmails = () => {
    // In a real app, this would fetch new emails
    // For now, just show a notification effect
    const button = document.getElementById("refresh-button");
    button.classList.add("animate-spin");
    setTimeout(() => button.classList.remove("animate-spin"), 1000);
  };

  return (
    <SubPageLayout
      breadcrumbItems={[
        { label: "Advisor Portal", path: "/advisor-portal" },
        { label: "Email", path: "/advisor-portal/email" },
      ]}
      title="Email"
      subtitle="Manage your email communications"
      actionButton={
        <button
          onClick={() => setShowEmailComposer(true)}
          className="px-4 py-2 bg-[#029831] text-white rounded-lg hover:bg-[#018529] transition-colors flex items-center"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
          Compose
        </button>
      }
    >
      <div className="h-[900px] bg-surface-default dark:bg-surface-default">
        {/* Email Type Filters */}
        <div className="border-b p-4 flex items-center space-x-2">
          <button
            onClick={() => toggleEmailType("all")}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
              selectedTypes.size === Object.values(EMAIL_TYPES).length
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-600 dark:text-gray-400 hover:bg-gray-200"
            }`}
          >
            All
          </button>
          <button
            onClick={() => toggleEmailType(EMAIL_TYPES.CLIENT)}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
              selectedTypes.has(EMAIL_TYPES.CLIENT)
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-600 dark:text-gray-400 hover:bg-gray-200"
            }`}
          >
            Clients
          </button>
          <button
            onClick={() => toggleEmailType(EMAIL_TYPES.POTENTIAL_CLIENT)}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
              selectedTypes.has(EMAIL_TYPES.POTENTIAL_CLIENT)
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-600 dark:text-gray-400 hover:bg-gray-200"
            }`}
          >
            Potential Clients
          </button>
          <button
            onClick={() => toggleEmailType(EMAIL_TYPES.INTERNAL)}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
              selectedTypes.has(EMAIL_TYPES.INTERNAL)
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-600 dark:text-gray-400 hover:bg-gray-200"
            }`}
          >
            Internal
          </button>
          <button
            onClick={() => toggleEmailType(EMAIL_TYPES.EXTERNAL)}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
              selectedTypes.has(EMAIL_TYPES.EXTERNAL)
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-600 dark:text-gray-400 hover:bg-gray-200"
            }`}
          >
            External
          </button>
        </div>

        {/* Email Header with Bulk Actions */}
        <div className="border-b p-4 flex items-center justify-between">
          <div className="flex space-x-2">
            {selectedEmails.size > 0 ? (
              <>
                <button
                  className="px-3 py-1 text-gray-700 dark:text-gray-300 bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center"
                  onClick={() => {
                    // Mark selected emails as read
                    setEmails(
                      emails.map((email) =>
                        selectedEmails.has(email.id)
                          ? { ...email, unread: false }
                          : email,
                      ),
                    );
                    setSelectedEmails(new Set());
                  }}
                >
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Mark as Read
                </button>
                <button
                  className="px-3 py-1 text-gray-700 dark:text-gray-300 bg-gray-100 hover:bg-gray-200 rounded-lg"
                  onClick={() => setSelectedEmails(new Set())}
                >
                  Clear Selection
                </button>
              </>
            ) : (
              <>
                <button
                  id="refresh-button"
                  onClick={refreshEmails}
                  className="p-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors group relative"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                  </svg>
                  <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white px-2 py-1 rounded text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                    Refresh
                  </span>
                </button>
                <button
                  onClick={() => markAllAsRead()}
                  className="p-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors group relative"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21.17,3.25L21.17,3.25l-0.96-0.96c-0.39-0.39-1.02-0.39-1.41,0l-0.97,0.97L19.23,4.66l0.94-0.94 C20.56,3.33,20.56,2.69,21.17,3.25z M18.06,5.83l1.41,1.41L9.91,16.8L8.5,15.39L18.06,5.83z M4,12c0,4.42,3.58,8,8,8 c4.42,0,8-3.58,8-8s-3.58-8-8-8C7.58,4,4,7.58,4,12z M12,2c5.52,0,10,4.48,10,10s-4.48,10-10,10S2,17.52,2,12S6.48,2,12,2z" />
                  </svg>
                  <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white px-2 py-1 rounded text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                    Mark all as read
                  </span>
                </button>
                <button
                  onClick={() => {
                    if (
                      window.confirm(
                        "Are you sure you want to delete all read emails?",
                      )
                    ) {
                      deleteEmails(
                        emails.filter((e) => !e.unread).map((e) => e.id),
                      );
                    }
                  }}
                  className="p-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors group relative"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M15 4V3H9v1H4v2h1v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6h1V4h-5zm0 15H9V8h6v11zm-4-8h2v7h-2z" />
                  </svg>
                  <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white px-2 py-1 rounded text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                    Delete read emails
                  </span>
                </button>
              </>
            )}
          </div>
          <div className="flex items-center space-x-4">
            <input
              type="text"
              placeholder="Search emails..."
              className="px-4 py-2 border rounded-lg w-64 text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            <button className="p-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Status Bar */}
        <div className="border-b px-4 py-2 flex items-center justify-between bg-gray-50">
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Viewing {(currentPage - 1) * emailsPerPage + 1}-
              {Math.min(currentPage * emailsPerPage, totalEmails)} of{" "}
              {totalEmails}
            </span>
            <span className="text-sm font-medium text-blue-600">
              {unreadCount} unread
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <button
              className="p-1 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:text-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="p-1 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:text-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Email List with Updated Checkbox Handling */}
        <div className="flex-1 overflow-auto">
          {currentEmails.map((email) => (
            <div
              key={email.id}
              onClick={() => openEmailDetail(email)}
              className={`flex items-center px-4 py-3 border-b hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer ${
                email.unread ? "bg-blue-50" : ""
              } ${selectedEmails.has(email.id) ? "bg-blue-50" : ""}`}
            >
              <div className="flex items-center w-64">
                <input
                  type="checkbox"
                  checked={selectedEmails.has(email.id)}
                  onChange={(e) => toggleEmailSelection(email.id, e)}
                  onClick={(e) => e.stopPropagation()}
                  className="mr-4 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <button
                  onClick={(e) => toggleStar(email.id, e)}
                  className="mr-4 text-gray-400 hover:text-gray-600 dark:text-gray-400"
                >
                  <svg
                    className={`w-5 h-5 ${email.isStarred ? "text-yellow-400" : "text-gray-400"}`}
                    fill={email.isStarred ? "currentColor" : "none"}
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                    />
                  </svg>
                </button>
                <div>
                  <span
                    className={`text-sm ${email.unread ? "font-semibold" : "font-medium"} text-gray-900 dark:text-gray-100`}
                  >
                    {email.sender}
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-500 block">
                    {email.senderEmail}
                  </span>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center">
                  <span
                    className={`${email.unread ? "font-semibold" : "font-medium"} text-gray-900 dark:text-gray-100 truncate`}
                  >
                    {email.subject}
                  </span>
                  <span className="mx-2">-</span>
                  <span className="text-gray-600 dark:text-gray-400 truncate">
                    {email.preview}
                  </span>
                </div>
              </div>
              <div className="w-32 flex items-center justify-end space-x-2">
                {email.hasAttachment && (
                  <svg
                    className="w-4 h-4 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" />
                  </svg>
                )}
                <span className="text-sm text-gray-500 dark:text-gray-500">{email.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Email Detail Modal with Working Reply/Forward */}
      {selectedEmail && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-100 rounded-lg w-full max-w-4xl h-[80vh] flex flex-col">
            <div className="flex justify-between items-center p-6 border-b bg-surface-default dark:bg-surface-default">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                {selectedEmail.subject}
              </h2>
              <button
                onClick={() => setSelectedEmail(null)}
                className="text-gray-500 dark:text-gray-500 hover:text-gray-700 dark:text-gray-300"
              >
                ✕
              </button>
            </div>
            <div className="flex-1 overflow-auto p-6 bg-surface-default dark:bg-surface-default">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <div className="flex items-center space-x-2">
                    <span className="font-medium text-gray-900 dark:text-gray-100">
                      {selectedEmail.sender}
                    </span>
                    <span className="text-gray-500 dark:text-gray-500">
                      &lt;{selectedEmail.senderEmail}&gt;
                    </span>
                  </div>
                  <div className="text-sm text-gray-500 dark:text-gray-500 mt-1">To: me</div>
                </div>
                <div className="text-sm text-gray-500 dark:text-gray-500">
                  {selectedEmail.time}
                  {selectedEmail.hasAttachment && (
                    <div className="flex items-center mt-1 text-blue-600">
                      <svg
                        className="w-4 h-4 mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" />
                      </svg>
                      <span>1 Attachment</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="prose max-w-none">
                <p className="text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
                  Dear [Advisor Name],
                  <br />
                  <br />
                  {selectedEmail.preview}
                  <br />
                  <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                  <br />
                  <br />
                  Best regards,
                  <br />
                  {selectedEmail.sender}
                </p>
              </div>
              {selectedEmail.hasAttachment && (
                <div className="mt-6 border rounded-lg p-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
                    Attachments
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center p-2 border rounded hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                      <svg
                        className="w-8 h-8 text-gray-400 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                          Document.pdf
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-500">2.4 MB</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="p-6 border-t flex justify-end space-x-4 bg-surface-default dark:bg-surface-default">
              <button
                onClick={() => handleReply(selectedEmail)}
                className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 hover:bg-gray-200 rounded-lg"
              >
                Reply
              </button>
              <button
                onClick={() => handleForward(selectedEmail)}
                className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 hover:bg-gray-200 rounded-lg"
              >
                Forward
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Email Composer Modal with Reply/Forward Support */}
      {showEmailComposer && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-100 rounded-lg w-full max-w-2xl">
            <div className="flex justify-between items-center p-6 border-b bg-surface-default dark:bg-surface-default">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                {replyToEmail
                  ? replyToEmail.subject.startsWith("Fwd:")
                    ? "Forward Email"
                    : "Reply to Email"
                  : "Compose Email"}
              </h2>
              <button
                onClick={() => {
                  setShowEmailComposer(false);
                  setReplyToEmail(null);
                }}
                className="text-gray-500 dark:text-gray-500 hover:text-gray-700 dark:text-gray-300"
              >
                ✕
              </button>
            </div>
            <div className="p-6 space-y-4 bg-surface-default dark:bg-surface-default">
              <input
                type="text"
                placeholder="To"
                value={replyToEmail ? replyToEmail.senderEmail : ""}
                className="w-full p-2 border rounded-lg text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-surface-default dark:bg-surface-default"
              />
              <input
                type="text"
                placeholder="Subject"
                value={
                  replyToEmail
                    ? replyToEmail.subject.startsWith("Re:")
                      ? replyToEmail.subject
                      : `Re: ${replyToEmail.subject}`
                    : ""
                }
                className="w-full p-2 border rounded-lg text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-surface-default dark:bg-surface-default"
              />
              <textarea
                placeholder="Message"
                rows={6}
                value={
                  replyToEmail
                    ? `\n\nOn ${replyToEmail.time}, ${replyToEmail.sender} wrote:\n> ${replyToEmail.preview}`
                    : ""
                }
                className="w-full p-2 border rounded-lg resize-none text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-surface-default dark:bg-surface-default"
              />
              <div className="flex justify-between items-center">
                <button className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:text-gray-200 flex items-center">
                  <svg
                    className="w-5 h-5 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" />
                  </svg>
                  Attach
                </button>
                <div className="space-x-2">
                  <button
                    onClick={() => setShowEmailComposer(false)}
                    className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-200 hover:bg-gray-300 rounded-lg"
                  >
                    Save Draft
                  </button>
                  <button className="px-4 py-2 bg-[#029831] text-white rounded-lg hover:bg-[#018529]">
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </SubPageLayout>
  );
};

export default Email;
